/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMenuItemFragment, MenuItemFragment, FullMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item';

/**
 * Get a single MenuItem by ID (base - scalars only)
 */
export const getBaseMenuItemById = gql`
  ${BaseMenuItemFragment}

  query GetBaseMenuItemById($id: String!, $locale: String!, $preview: Boolean) {
    menuItem(id: $id, locale: $locale, preview: $preview) {
      ...BaseMenuItemFragment
    }
  }
`;

/**
 * Get a single MenuItem by ID (standard - 1 level deep)
 */
export const getMenuItemById = gql`
  ${MenuItemFragment}

  query GetMenuItemById($id: String!, $locale: String!, $preview: Boolean) {
    menuItem(id: $id, locale: $locale, preview: $preview) {
      ...MenuItemFragment
    }
  }
`;

/**
 * Get a single MenuItem by ID (full - 2 levels deep)
 */
export const getFullMenuItemById = gql`
  ${FullMenuItemFragment}

  query GetFullMenuItemById($id: String!, $locale: String!, $preview: Boolean) {
    menuItem(id: $id, locale: $locale, preview: $preview) {
      ...FullMenuItemFragment
    }
  }
`;

/**
 * Get all MenuItem entries with pagination (base - scalars only)
 */
export const getBaseMenuItems = gql`
  ${BaseMenuItemFragment}

  query GetBaseMenuItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MenuItemOrder]
    $where: MenuItemFilter
    $preview: Boolean
  ) {
    menuItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseMenuItemFragment
      }
    }
  }
`;

/**
 * Get all MenuItem entries with pagination (standard - 1 level deep)
 */
export const getMenuItems = gql`
  ${MenuItemFragment}

  query GetMenuItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MenuItemOrder]
    $where: MenuItemFilter
    $preview: Boolean
  ) {
    menuItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...MenuItemFragment
      }
    }
  }
`;

/**
 * Get all MenuItem entries with pagination (full - 2 levels deep)
 */
export const getFullMenuItems = gql`
  ${FullMenuItemFragment}

  query GetFullMenuItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [MenuItemOrder]
    $where: MenuItemFilter
    $preview: Boolean
  ) {
    menuItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullMenuItemFragment
      }
    }
  }
`;
